import { render, staticRenderFns } from "./AdminMenuRoles.vue?vue&type=template&id=1765954c&scoped=true"
import script from "./AdminMenuRoles.vue?vue&type=script&lang=js"
export * from "./AdminMenuRoles.vue?vue&type=script&lang=js"
import style0 from "./AdminMenuRoles.vue?vue&type=style&index=0&id=1765954c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1765954c",
  null
  
)

export default component.exports